import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "filter",
  "use": "filter-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 24 24\" id=\"filter\">\n<path d=\"M14,22c-0.2,0-0.3,0-0.4-0.1l-4-2C9.2,19.7,9,19.4,9,19v-6.2L1.2,3.6C1,3.3,0.9,2.9,1.1,2.6C1.3,2.2,1.6,2,2,2h20\n\tc0.4,0,0.7,0.2,0.9,0.6s0.1,0.8-0.1,1.1L15,12.8V21c0,0.3-0.2,0.7-0.5,0.9C14.4,22,14.2,22,14,22z M11,18.4l2,1v-6.9\n\tc0-0.2,0.1-0.5,0.2-0.6L19.8,4H4.2l6.6,7.8c0.2,0.2,0.2,0.4,0.2,0.6V18.4z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol